import IDoctor from '@interfaces/IDoctor'
import IPatient from '@interfaces/IPatient'
import axios from 'axios'

export const securityCode = (email: string, password: string, sendToN8n = false) => axios.post('v1/catalogo/auth/security-code', {
  email,
  password,
  send_to_n8n: sendToN8n,
})

export const login = (email: string, password: string, securityCode?: string): Promise<any> => axios.post('v1/catalogo/auth/login', {
  email,
  password,
  security_code: securityCode,
})

export const register = (patient: IPatient): Promise<any> => axios.post('v1/catalogo/auth/register', patient)

export const registerDoctor = (doctor: IDoctor): Promise<any> => axios.post('v1/catalogo/auth/register/doctor', doctor)

export const me = (): Promise<any> => axios.get('v1/catalogo/auth/me')

export const forgotPassword = (email: string): Promise<Response> => axios.post('v1/catalogo/auth/forgot-password', {
  email,
})

export const resetPassword = (token: string, email: string, password: string, passwordConfirmation: string): Promise<Response> => axios.post('v1/catalogo/auth/reset-password', {
  token,
  email,
  password,
  password_confirmation: passwordConfirmation,
})

export const verifyEmail = (email: string, id: string, hash: string): Promise<Response> => axios.get(`v1/catalogo/auth/verify-email/${email}/${id}/${hash}`)

export const resendVerifyEmail = (email: string): Promise<Response> => axios.post('v1/catalogo/auth/resend-verify-email', {
  email,
})